import React, { } from 'react'

import { Grid, Typography, Checkbox, IconButton, ButtonBase } from '@material-ui/core'
import TreeItem from '@material-ui/lab/TreeItem'

import RemoveCircleOutlineOutlinedIcon from '@material-ui/icons/RemoveCircleOutlineOutlined'
import AddCircleOutlineOutlinedIcon from '@material-ui/icons/AddCircleOutlineOutlined'

import { withStyles, makeStyles } from '@material-ui/core/styles'
import { keyify2 } from '../../../utils/functions/infoFunctions'

const useStyles = makeStyles((theme) => ({
  parentText: {
    color: '#97b557',
    fontWeight: 700
  },
  childText: {
    color: '#007BFF',
    fontWeight: 700
  },
  selectedKey: {
    backgroundColor: theme.palette.action.selected
  },
  treeItem: {
    pointerEvents: 'none'
  }
}))

const GreenCheckbox = withStyles((theme) => ({
  root: {
    color: '#595959',
    '&$checked': {
      color: '#A4D164'
    },
    padding: theme.spacing(1)
  },
  checked: {}
}))((props) => <Checkbox color='default' {...props} />)

// determine if a checkbox should appear checked
const unitIsVisuallySelected = (key, selectedKeys, children = []) => {
  if (selectedKeys.length) {
    // if the selected unit has no child units, then base the displayed check on if the item has been selected
    if (!children.length) {
      return Boolean(selectedKeys.findIndex((selectedKey) => selectedKey === key) !== -1)
    } else {
      // otherwise, only display the parent as selected if all childless descendants are selected
      const allChildKeys = keyify2(children, true)
      return Boolean(allChildKeys.every(key => selectedKeys.includes(key)))
    }
  }

  // if there are no selected keys then no box should be checked
  return false
}
/**
 * UnitTreeItem component used to display material ui tree
 * @param {Array} treeData parent child unit structure
 * @param {Function} onUnitClick function called when node is selected, ONLY to be used when checkboxes are enabled
 * @param {Function} onNodeSelect function called when a node is clicked on
 * @param {Function} onNodeAugment function called when a user attempts to condense or expand a tree branch
 * @param {Array} ancestors node ancestors
 * @param {Array} selectedKeys array of current keys selected
 * @param {Boolean} isCheckbox whether checkboxes should be added to tree items
 */
const UnitTreeItem = (props) => {
  const classes = useStyles()
  const {
    onUnitClick = () => { },
    onNodeSelect = () => { },
    onNodeAugment = () => { },
    ancestors = [],
    selectedKeys = [],
    treeData = [],
    expandedKeys = [],
    isCheckbox = false
  } = props

  return (
    <>
      {
        treeData.length ? treeData.map((item) => {
          const { key, title, children } = item
          // determine if the checkbox should appear to be checked (note: if a parent key, it can appear checked without its actual unitID being selected. This is to allow for users with limited access to easily select only those units relative to them.)
          const isChecked = unitIsVisuallySelected(key, selectedKeys, children)

          // determines if the key is actually selected
          const isSelected = selectedKeys ? selectedKeys.findIndex((selectedKey) => selectedKey === key) !== -1 : false
          const isExpanded = expandedKeys ? expandedKeys.findIndex((expandedKey) => expandedKey === key) !== -1 : false

          return (
            <TreeItem
              nodeId={key}
              className={!isCheckbox ? classes.treeItem : ''}
              onClick={() => { if (isCheckbox) { onUnitClick(ancestors, key, isChecked, children) } }}
              label={
                <>
                  {
                    isCheckbox
                      ? (
                        <Grid container direction='row' alignItems='center'>
                          <Grid item>
                            <GreenCheckbox
                              checked={isChecked}
                              // onClick={() => onUnitClick(ancestors, key, isChecked, childKeys)} NOTE: this was firing twice as it is handled here and in the 'Tree Item' level. Leaving in case it is needed elsewhere but I think it can be removed
                            />
                          </Grid>

                          <Grid item>
                            <Typography variant='body2' className={children.length ? classes.parentText : classes.childText}>{title.replace('_', ' ')}</Typography>
                          </Grid>
                        </Grid>
                      ) : (
                        <Grid container direction='row' alignItems='center' className={!isCheckbox && isSelected ? classes.selectedKey : ''}>
                          <Grid item xs={2} style={{ visibility: children.length ? 'visible' : 'hidden' }}>
                            <IconButton
                              size='small'
                              style={{ pointerEvents: 'all' }}
                              onClick={() => onNodeAugment(key, children, isExpanded)}
                              className={classes.augmentBtn}
                            >
                              {
                                isExpanded
                                  ? (
                                    <RemoveCircleOutlineOutlinedIcon />
                                  ) : (
                                    <AddCircleOutlineOutlinedIcon />
                                  )
                              }
                            </IconButton>
                          </Grid>
                          <Grid item xs={10}>
                            <ButtonBase
                              style={{ pointerEvents: 'all' }}
                              onClick={() => onNodeSelect(key, title, children.length ? true : !true)}
                              className='w-100'
                            >
                              <Typography
                                variant='body1'
                                align='left'
                                className={`${children.length ? classes.parentText : classes.childText} w-100`}
                              >
                                {title.replace('_', ' ')}
                              </Typography>
                            </ButtonBase>
                          </Grid>
                        </Grid>
                      )
                  }
                </>
              }
              key={`tree-item-${key}`}
            >
              {
                children.length
                  ? (
                    <UnitTreeItem
                      treeData={children}
                      onUnitClick={onUnitClick}
                      onNodeSelect={onNodeSelect}
                      onNodeAugment={onNodeAugment}
                      isCheckbox={isCheckbox}
                      // isParentSelected={selectedKeys ? selectedKeys.findIndex((selectedKey) => selectedKey === key) !== -1 : false}
                      ancestors={[...ancestors, key]}
                      selectedKeys={selectedKeys}
                      expandedKeys={expandedKeys}
                    />
                  ) : <></>
              }
            </TreeItem>
          )
        }) : <></>
      }
    </>

  )
}

export default UnitTreeItem
